import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Outlet } from '@assetmark/ewm30-routing-shell';
import { FooterFragment } from '../../remote-components/FooterFragment';
import { Suspense } from 'react';
import { ModuleFallbackComponent, moduleLoadingError, } from '../../helpers/ModuleFallbackComponent';
import { ErrorBoundary } from 'react-error-boundary';
import { HeaderFragment } from '../../remote-components/HeaderFragment';
import classNames from 'classnames';
import styles from './DefaultLayout.module.scss';
const LAYOUT_GRID_TEMPLATE = '106px auto 43px';
/**
 * Allow to use children for cases like NotFoundPage
 * @param children
 * @constructor
 */
export const DefaultLayout = ({ children }) => {
    return (_jsxs("section", { className: styles.layout, style: { gridTemplateRows: LAYOUT_GRID_TEMPLATE }, children: [_jsx("div", { className: styles.headerWrapper, children: _jsx(HeaderFragment, {}) }), _jsx("div", { className: classNames('apps-container', styles.appWrapper), "data-testid": "app-container", children: _jsx(Suspense, { children: _jsxs(ErrorBoundary, { FallbackComponent: ModuleFallbackComponent, onError: moduleLoadingError, children: [children, _jsx(Outlet, {})] }) }) }), _jsx("div", { className: styles.footerWrapper, children: _jsx(FooterFragment, {}) })] }));
};
